class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.getUserCountry();
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: '/?view=sections'
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (globalThis.PS.templateName === 'cart' && parsedState.item_count === 0) {
          globalThis.location.href = '/cart';
        } else {
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          
          this.getSectionsToRender().forEach((section => {
            const elementID = document.getElementById(section.id);
            if (elementID) {
              const elementToReplace = elementID.querySelector(section.selector) || document.getElementById(section.id);
              if (elementToReplace) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              } else {
                console.log('couldnt find section: '+section.selector);
              }
            } else {
              console.log('couldnt find section: '+section.selector);
            }
          }));
  
          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          this.disableLoading();
        }
      }).catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  getFreeShippingContent(countryCode) {
    fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET'
      })
      .then(response => response.json())
      .then(data => {
        // init AU settings
        let cart_total = data.total_price;
        let enabled_free_gift = window.freeShipping.enabled_free_gift;
        let enabled_express_shipping = window.freeShipping.enabled_express_shipping;
        let free_gift_product_id = window.freeShipping.free_gift_product_id;
        let success_message = window.freeShipping.goal_success_message_au;
        let progress_message = window.freeShipping.goal_progress_message_au;
        let express_success_message = window.freeShipping.express_goal_success_message_au;
        let express_progress_message = window.freeShipping.express_goal_progress_message_au;
        let gift_success_message = window.freeShipping.gift_goal_success_message_au;
        let gift_progress_message = window.freeShipping.gift_goal_progress_message_au;
        let threshold = window.freeShipping.global_threshold_au;
        let express_threshold = window.freeShipping.express_goal_threshold;
        let gift_threshold = window.freeShipping.gift_goal_threshold;
        // init NZ settings
        if (countryCode == 'NZ') {
            success_message = window.freeShipping.goal_success_message_nz;
            progress_message = window.freeShipping.goal_progress_message_nz;
            express_success_message = window.freeShipping.express_goal_success_message_nz;
            express_progress_message = window.freeShipping.express_goal_progress_message_nz;
            gift_success_message = window.freeShipping.gift_goal_success_message_nz;
            gift_progress_message = window.freeShipping.gift_goal_progress_message_nz;
            threshold = window.freeShipping.global_threshold_nz;
            express_threshold = window.freeShipping.express_goal_threshold_nz;
            gift_threshold = window.freeShipping.gift_goal_threshold_nz;
            enabled_free_gift = window.freeShipping.enabled_free_gift_nz;
            enabled_express_shipping = window.freeShipping.enabled_express_shipping_nz;
        }
        //init US settings
        if (countryCode == 'US') {
          success_message = window.freeShipping.goal_success_message_us;
          progress_message = window.freeShipping.goal_progress_message_us;
          express_success_message = window.freeShipping.express_goal_success_message_us;
          express_progress_message = window.freeShipping.express_goal_progress_message_us;
          gift_success_message = window.freeShipping.gift_goal_success_message_us;
          gift_progress_message = window.freeShipping.gift_goal_progress_message_us;
          threshold = window.freeShipping.global_threshold_us;
          express_threshold = window.freeShipping.express_goal_threshold_us;
          gift_threshold = window.freeShipping.gift_goal_threshold_us;
          enabled_free_gift = window.freeShipping.enabled_free_gift_us;
          enabled_express_shipping = window.freeShipping.enabled_express_shipping_us;
        }
        // init SG settings
        if (countryCode == 'SG') {
          success_message = window.freeShipping.goal_success_message_sg;
          progress_message = window.freeShipping.goal_progress_message_sg;
          express_success_message = window.freeShipping.express_goal_success_message_sg;
          express_progress_message = window.freeShipping.express_goal_progress_message_sg;
          gift_success_message = window.freeShipping.gift_goal_success_message_sg;
          gift_progress_message = window.freeShipping.gift_goal_progress_message_sg;
          threshold = window.freeShipping.global_threshold_sg;
          express_threshold = window.freeShipping.express_goal_threshold_sg;
          gift_threshold = window.freeShipping.gift_goal_threshold_sg;
          enabled_free_gift = window.freeShipping.enabled_free_gift_sg;
          enabled_express_shipping = window.freeShipping.enabled_express_shipping_sg;
        }

        // init DOM elements
        const cartLoadingWrapper = document.querySelector('.cart-loading-wrapper');
        const cartProgressWrapper = document.querySelector('.cart__progress-bar');
        const cartProgressBarShipping = document.querySelector('.cart__progress-bar--wrapper.shipping');
        const cartProgressBarExpress = document.querySelector('.cart__progress-bar--wrapper.express');
        const cartProgressBarGift = document.querySelector('.cart__progress-bar--wrapper.gift');
        const shippingTopMessage = document.querySelector('.cart__shipping-top-message');
        const shippingBottomMessage = document.querySelector('.cart__shipping-bottom-message');
        const percentageProgressShipping = document.querySelector('.shipping .cart__progress-bar-percentage');
        const percentageProgressExpress = document.querySelector('.express .cart__progress-bar-percentage');
        const percentageProgressGift = document.querySelector('.gift .cart__progress-bar-percentage');
        const iconDescriptionShipping = document.querySelector('.cart__progress-bar--wrapper.shipping .cart__icon-description');
        const iconDescriptionExpress = document.querySelector('.cart__progress-bar--wrapper.express .cart__icon-description');

        // init progress variables
        let shipping_progress = 0;
        let express_progress = 0;
        let gift_progress = 0;
        let top_message = '';
        let bottom_message = '';
        let icon_message = '';
        let current_progress = 0;
        let gift_success = false;

        // init helper functions
        const formattedAmount = (amount) => {
          return (amount / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
          });
        };
      
        const setProgressWidth = (element, progress) => {
          if (element) {
            element.style.width = `${progress}%`;
          }
        };
      
        const addClass = (element, className) => {
          if (element) {
            element.classList.add(className);
          }
        };
      
        const removeClass = (element, className) => {
          if (element) {
            element.classList.remove(className);
          }
        };

        // calculate progress bar percentage
        const calculateProgress = (current, start, end) => {
          return ((current - start) / (end - start)) * 100;
        };

        // display icon message if a available threshold isn't reached yet 
        const getIconMessage = () => {
          return (cart_total < threshold) || enabled_express_shipping || enabled_free_gift ? '<span>Click on icon to learn more</span>' : '';
        }
        
        // gift threshold reached
        if (enabled_free_gift && cart_total > gift_threshold) {
          shipping_progress = 100;
          express_progress = 100;
          gift_progress = 100;
          top_message = gift_success_message;
          gift_success = true;

          addClass(cartProgressBarShipping, 'reached');
          addClass(cartProgressBarExpress, 'reached');
          addClass(cartProgressBarGift, 'reached');
          removeClass(iconDescriptionShipping, 'right-aligned');
          removeClass(iconDescriptionExpress, 'right-aligned');
          removeClass(cartProgressBarGift, 'hidden');

          if (enabled_express_shipping) {
            removeClass(cartProgressBarExpress, 'hidden');
          }
        }
        // express threshold reached
        else if (enabled_express_shipping && cart_total > express_threshold) {
          shipping_progress = 100;
          express_progress = 100;
          top_message = express_success_message;
          current_progress = gift_threshold - cart_total;
          icon_message = getIconMessage();

          addClass(cartProgressBarShipping, 'reached');
          addClass(cartProgressBarExpress, 'reached');
          removeClass(cartProgressBarExpress, 'hidden');
          removeClass(iconDescriptionShipping, 'right-aligned');

          if (enabled_free_gift) {
            removeClass(cartProgressBarGift, 'hidden');
            gift_progress = calculateProgress(cart_total, express_threshold, gift_threshold);
            current_progress = gift_threshold - cart_total;
            bottom_message = gift_progress_message;
          }
        }
        // shipping threshold reached
        else if (cart_total > threshold) {
          shipping_progress = 100;
          top_message = success_message;
          icon_message = getIconMessage();
          addClass(cartProgressBarShipping, 'reached');

          if (enabled_express_shipping) {
            removeClass(cartProgressBarExpress, 'hidden');
            current_progress = express_threshold - cart_total;
            express_progress = calculateProgress(cart_total, threshold, express_threshold);
            gift_progress = 0;
            bottom_message = express_progress_message;
          }
          else if (enabled_free_gift) {
            addClass(cartProgressBarExpress, 'reached');
            express_progress = 100;
            gift_progress = calculateProgress(cart_total, threshold, gift_threshold);
            bottom_message = gift_progress_message;
            current_progress = gift_threshold - cart_total;
          }
          if (enabled_free_gift) {
            removeClass(iconDescriptionExpress, 'right-aligned');
            removeClass(cartProgressBarGift, 'hidden');
          }
        }
        // shipping threshold not reached
        else {
          shipping_progress = cart_total / threshold * 100;
          top_message = progress_message;
          current_progress = threshold - cart_total;
          icon_message = getIconMessage();
          
          if (enabled_express_shipping) {
            removeClass(iconDescriptionShipping, 'right-aligned');
            removeClass(cartProgressBarExpress, 'hidden');
          }
          if (enabled_free_gift) {
            removeClass(iconDescriptionShipping, 'right-aligned');
            removeClass(iconDescriptionExpress, 'right-aligned');
            removeClass(cartProgressBarGift, 'hidden');
          }
        }
        
        // update messages with formatted amount 
        if (current_progress > 0) {
          const formattedPrice = formattedAmount(current_progress);
          top_message = top_message.replace('[amount]', formattedPrice);
          bottom_message = bottom_message.replace('[amount]', formattedPrice);
        }

        // update DOM elements
        if (shippingTopMessage) {
          shippingTopMessage.innerHTML = '';
          shippingTopMessage.insertAdjacentHTML('beforeend', top_message);
          if (icon_message) {
            shippingTopMessage.insertAdjacentHTML('beforeend', icon_message);
          }
        }
        if (shippingBottomMessage) {
          shippingBottomMessage.innerHTML = '';
          shippingBottomMessage.insertAdjacentHTML('afterbegin', bottom_message);
        }

        // set progress bar
        setProgressWidth(percentageProgressShipping, shipping_progress);
        setProgressWidth(percentageProgressExpress, express_progress);
        setProgressWidth(percentageProgressGift, gift_progress);
        
        // remove loading
        addClass(cartLoadingWrapper, 'hidden');
        removeClass(cartProgressWrapper, 'hidden');
        removeClass(shippingTopMessage, 'hidden');

        if (enabled_free_gift && free_gift_product_id) {
          this.validateFreeGiftProduct(data, gift_success, free_gift_product_id);
        }
      });
  }

  // add/remove free gift functionality
  // data: cart data, gift_success: free gift reached
  validateFreeGiftProduct(data, gift_success, free_gift_product_id) {
    let giftInCart = false;
    for (let i = 0; i < data.items.length; i++) {
      let variant_id = data.items[i].variant_id;
      if (variant_id.toString() == free_gift_product_id) {
        giftInCart = true;
        if (gift_success) {
          if (data.items[i].quantity > 1) {
            this.updateQuantity(i + 1, 1);
          }
        }
        else {
          this.updateQuantity(i + 1, 0);
        }
      }
    }
    if (gift_success && !giftInCart) {
      const freeGiftForm = document.querySelector('.cart__free-gift-form form .quick-add__submit');
      freeGiftForm.click();
    }
  }

  async getUserCountry() {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      this.getFreeShippingContent(data.country_code);
    } catch (error) {
      console.error('Error fetching user country:', error);
    } 
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};